// ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
/* eslint-disable */

import type * as Types from '../../../../../../../schema';

import fetchGraphql from '@/server/helpers/fetchQuery';
import gql from '@/shared/utils/gql';
export type OtherFreebetRewardsQueryVariables = Types.Exact<{
  game: Types.Scalars['ID']['input'];
  currency: Types.Scalars['String']['input'];
  inGameCurrency?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type OtherFreebetRewardsQuery = { __typename?: 'Query', rewards?: { __typename?: 'Rewards', id: string, myOtherFreebetRewards?: { __typename?: 'RewardsRewardInstanceConnection', edges?: Array<{ __typename?: 'RewardsRewardInstanceEdge', node?: { __typename?: 'RewardsRewardInstance', id: string, currency?: string, valueCurrency?: string, inGameCurrency?: string } }> } } };

export type OtherFreebetRewardFragment = { __typename?: 'RewardsRewardInstance', id: string, currency?: string, valueCurrency?: string, inGameCurrency?: string };

export const OtherFreebetRewardFragmentDoc = gql`
    fragment OtherFreebetRewardFragment on RewardsRewardInstance {
  id
  currency
  valueCurrency
  inGameCurrency: integrationCurrency
}
    `;
export const OtherFreebetRewardsQueryDocument = gql`
    query OtherFreebetRewardsQuery($game: ID!, $currency: String!, $inGameCurrency: String) {
  rewards {
    id
    myOtherFreebetRewards(
      game: $game
      currency: $currency
      integrationCurrency: $inGameCurrency
    ) {
      edges {
        node {
          ...OtherFreebetRewardFragment
        }
      }
    }
  }
}
    ${OtherFreebetRewardFragmentDoc}`;

export const getOtherFreebetRewardsQuery = async (variables: OtherFreebetRewardsQueryVariables) => {
  return fetchGraphql<OtherFreebetRewardsQuery, OtherFreebetRewardsQueryVariables>(OtherFreebetRewardsQueryDocument, "OtherFreebetRewardsQuery", { variables });
}